import { Layout } from "../components/Layout";

export function ComingSoonPage({ title, ships }: { title: string; ships: string }) {
  return (
    <Layout title={title}>
      <p className="help-line">
        <strong>{title}</strong> ships in {ships}. The v0.1 release wires up authentication, the
        shared layout, and the dashboard so we can validate the architecture end-to-end before
        building module features.
      </p>
      <section className="card">
        <h2>What this module will do</h2>
        <p>
          See the{" "}
          <a
            href="https://example.com"
            onClick={(e) => e.preventDefault()}
            aria-disabled="true"
          >
            Phase 1 plan
          </a>{" "}
          (delivered separately in the client package) for the full screen list, workflows, and
          permissions for this module.
        </p>
      </section>
    </Layout>
  );
}
